<template>
    <div class="search">
        <h1 class="sr-only">Search TONE</h1>
        <spinner v-model="spinner" size="lg" class="btn-spinner"> </spinner>
            <div class="container">
                <!-- Search Field Placeholder -->
                <div class="row">
                    <div class="col-md-12">
                        <alert v-model="isBlankField" placement="top-right" duration="0" type="info" width="400px" dismissable>
                            <span class="glyphicon glyphicon-exclamation-sign fa-2x pull-left"></span>
                            <p class="margin-top-5">Please type something, the input field seems to be blank.</p>
                        </alert>
                    </div>
                </div>
                <!-- Search Field -->
                <div class="row">
                    <div class="col-md-12">
                        <span></span>
                        <h3 v-if="!user && (getSearchResults ? getSearchResults.length : 0) !== 0 && currentPlan">Gain access to expert videos in the topics that interest you<span v-if="!isNativeApp"> for just ${{currentPlan.amount}} a month! </span><span v-else>!</span>
                            <br><a v-a11y-action style="cursor: pointer" @click="redirectToSignUp"><strong>Start your free trial today</strong></a>
                            <br />
                        </h3>
                        <form id="search_form" v-on:submit.prevent="initiateSearch">
                            <input aria-label="What can we help you find?" v-model="contentToSearch" type="text" placeholder="What can we help you find?">
                            <button type="submit" aria-label="Search" class="btn" v-bind:style="{ color: $a11yTextColor(getCorpButtonColor) + ' !important',  backgroundColor: getCorpButtonColor, border: '1px solid' + getCorpHeaderColor +' !important'}">
                                <i class="fa fa-search" aria-hidden="true"></i>
                            </button>
                        </form>
                    </div>
                </div>
                <!-- If there is np relevant result to show -->
                <div class="row">
                    <div class="col-md-12 margin-top-40">
                        <transition name="slide-search-fade">
                            <div role="status" class="text-center text-muted margin-bottom-40" v-if="isEmptyResponse">
                                <h1>No result found for <strong>{{enteredValue}}</strong>!</h1>
                            </div>
                            <div class="text-center text-success" v-if="(getSearchResults ? getSearchResults.length : 0) !== 0">
                                <h1>Search results for <strong>{{enteredValue}}</strong>
                                </h1>
                            </div>
                        </transition>
                    </div>
                </div>
                <!-- Main videos tabs if there is relevant data to show-->
                <!-- !isEmptyResponse this.searchResults === null && this.searchEventResults === null && this.searchPlaylistResult === null -->
                <div class="row"  v-if="!(this.searchResults === null && this.searchEventResults === null && this.searchPlaylistResult === null)">
                    <div class="col-md-12 margin-bottom-40">
                        <!-- div class="tabs-content" v-if="(getSearchResults ? getSearchResults.length : 0) !== 0" -->
                        <div class="tabs-content">
                            <div class="tabs m-b-45">
                                <ul>
                                    <li><span></span></li>
                                    <li @click="switchTab('videos')" :class="{ current: tabs.videos }" class="videoList"><a v-a11y-action :aria-pressed="(tabs.videos) ? 'true' : 'false'">videos (<b>{{getSearchPlaylistResults && getSearchResults.length ? getSearchResults.length : 0 }}</b>)</a></li>
                                    <li @click="switchTab('events')" :class="{ current: tabs.events }" class="videoList" ><a v-a11y-action :aria-pressed="(tabs.events) ? 'true' : 'false'"> Events (<b>{{getSearchExpertResults && getSearchExpertResults.length ? getSearchExpertResults.length : 0 }}</b>)</a></li>
                                    <li @click="switchTab('playlists')" :class="{ current: tabs.playlists }" class="videoList"><a v-a11y-action :aria-pressed="(tabs.playlists) ? 'true' : 'false'">Playlists (<b>{{getSearchPlaylistResults && getSearchPlaylistResults.userPlaylists && getSearchPlaylistResults.userPlaylists.length ? getSearchPlaylistResults.userPlaylists.length : 0 }}</b>)</a></li>
                                </ul>
                            </div>
                            <div class="tabContent" id="tabs-1" :class="{ current: tabs.videos }">

                                                                <!-- Sorting Tabs -->

                                <div class="container__header" v-if="(getSearchResults ? getSearchResults.length : 0) !== 0">
                                    <div v-a11y-action class="container__header-item" @click="sort('expertname')">
                                        Sort By Expert
                                        <i class="fa fa-sort"  aria-hidden="true"></i>
                                    </div>
                                    <div v-a11y-action class="container__header-item" @click="sort('_score')">
                                        Sort By Rating
                                        <i class="fa fa-sort"  aria-hidden="true"></i>
                                    </div>
                                </div>
                                                                    <!-- Figuing Out -->
                                <div class="row video-row">
                                    <div v-if="searchResults && searchResults" class="col-xs-12 col-sm-6 col-md-4 bottom-margin" :class="{'innerimggray': getTrialDays < 0}" v-for = "result in limitTo(searchResults)">
                                        <div v-if="user">
                                            <!-- a :href="'/watch/' + result.mediaid + '/' + result.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()" class="nounderline" -->
                                            <router-link :to="{ path: '/watch/' + result.mediaid + '/' + result.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()}"  class="nounderline">
                                                <div class="image-container">
                                                    <img class="jw-img-1" :src="result.image"  :alt="result.title" :title="result.title"/>
                                                    <p class="text-wrap-title-1 align-to-bottom cursor">{{ formattedDuration(result.duration) }}</p>
                                                </div>
                                                <p class="cursor video-title" >{{result.title}}</p>
                                            </router-link>
                                            <!-- /a -->
                                            <!-- div class="image-container">
                                                <img class="jw-img-1" :src="result.image" @click="playVideoFunc(result.videoCode, result.title)" :alt="result.title" :title="result.title" />
                                                <p class="text-wrap-title-1 align-to-bottom cursor">{{ formattedDuration(result.duration) }}</p>
                                            </div -->
                                            <!-- <img class="jw-img" :src="result.image" @click="setVideoPlayerObject(result.videoCode, result.title)" :alt="result.title" :title="result.title" /> -->
                                            <!-- p class="cursor video-title" @click="playVideoFunc(result.videoCode, result.title)">{{result.title}}</p -->
                                        </div>
                                        <div v-else>
                                            <div class="image-container">
                                                <!-- img class="jw-img-1" :src="result.image" @click="playVideoFunc(result.videoCode, result.title)" :alt="result.title" :title="result.title" / -->
                                                <img v-a11y-action :aria-label="result.title" class="jw-img-1" :src="result.image" @click="setVideoPlayerObject(result.videoCode, result.title)" :alt="result.title" :title="result.title" />
                                                <p class="text-wrap-title-1 align-to-bottom cursor">{{ formattedDuration(result.duration) }}</p>
                                            </div>
                                            <!-- <img class="jw-img" :src="result.image" @click="setVideoPlayerObject(result.videoCode, result.title)" :alt="result.title" :title="result.title" /> -->
                                            <!-- p class="cursor video-title" @click="playVideoFunc(result.videoCode, result.title)">{{result.title}}</p -->
                                            <p v-a11y-action class="cursor video-title" @click="setVideoPlayerObject(result.videoCode, result.title)">{{result.title}}</p>
                                        </div>
                                        <hr v-if="user">
                                        <div class="plusicon btn-group" v-if="user">
                                            <button aria-label="Add video to a playlist" title="Add to Playlist" :id="result.mediaid" type="button" @click="showPlaylistMenu(result.mediaid)" class="dropdown-toggle ellipsis pull-right">
                                                <!-- <img src="../assets/playlist-icon.png" class="menuiconbutton" alt="Playlist" title="Playlist"/>-->
                                                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="37px" height="24px" viewBox="0 0 37 24" enable-background="new 0 0 37 24" xml:space="preserve">
                                                    <rect y="0.2" :fill="getCorpHeaderColor" width="25" height="3"/>
                                                    <rect y="8.2" :fill="getCorpHeaderColor" width="25" height="3"/>
                                                    <rect y="17.2" :fill="getCorpHeaderColor" width="18.2" height="3"/>
                                                    <rect x="23" y="15.2" :fill="getCorpHeaderColor" width="14" height="4"/>
                                                    <rect x="27.958" y="10.242" :fill="getCorpHeaderColor" width="4" height="13.917"/>
                                                </svg>
                                            </button>
                                            <ul class="hide">
                                                <li  v-if="getUserPlaylists">
                                                    <label>
                                                        <b> Add to ...</b>
                                                    </label>
                                                </li>
                                                <li role="separator" class="divider"  v-if="getUserPlaylists"></li>
                                                <li  v-if="getUserPlaylists" v-for="playlist in getUserPlaylists">
                                                    <label class="notificationwithcheckboxes">
                                                        <input type="checkbox" :checked="verifyVideoExists(playlist, result)" @click="setPlaylistVideoStatus(result, playlist, verifyVideoExists(playlist, result)) "/> {{playlist.title}}
                                                        <transition name="fade">
                                                            <!--<h6 v-if="video.mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoAdded">Added</h6>-->
                                                            <span class="added" v-if="result.mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoAdded">Added</span>
                                                        </transition>
                                                        <transition name="fade">
                                                            <span class="removed" v-if="result.mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoRemoved">Removed</span>
                                                        </transition>
                                                    </label>
                                                </li>
                                                <!--<li>-->

                                                <!--</li>-->
                                                <li role="separator" class="divider" v-if="getUserPlaylists"></li>
                                                <li><label style="color:#f0617d">Create new playlist</label></li>
                                                <li><label>  <input aria-label="New playlist name" type="text" class="form-control" v-model="newPlaylistName" />
                                                    <i v-a11y-action aria-label="Insert New Playlist" class="fa fa-plus-circle" @click="addNewPlayList" title="Insert New Playlist"></i>

                                                </label> </li>
                                            </ul>
                                            <div class="backdropformenu"  @click="hidePlaylistMenu(result.mediaid)"></div>
                                        </div>
                                        <p class="right-heart-icon" v-if="user && getAuthUserVideos">
                                            <a v-a11y-action aria-label="Liked this video?" href="javascript:" @click="setVideoStatus(result)" title ="Liked this video?">
                                                <i class="fa fa-2x fa-heart-o" v-bind:style="{ color: getCorpHeaderColor}"
                                                    v-bind:class="{'activeIcons': getVideoStatus(result)}" aria-hidden="true" ></i></a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="tabContent" id="tabs-2" :class="{ current: tabs.events }">
                                <div class="row video-row">
                                    <div v-if="searchEventResults && searchEventResults.length > 0" class="col-xs-12 col-sm-6 col-md-4 bottom-margin" :class="{'innerimggray': getTrialDays < 0}" v-for = "result in limitTo(searchEventResults)">
                                    <div v-if="user">
                                        <!-- <p>Entered user</p> {{ result.eventId }} {{ result.title }} -->
                                        <!--
                                        <router-link :to="{ path: '/expert/' + expert.expertId + '/' + expert.name.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()}" >
                                        -->
                                        <router-link :to="{ path: '/tonearchive/' + result.eventId + '/play/1/' + result.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()}"  class="nounderline">
                                        <!-- a :href="`/tonearchive/${result.eventId}/play/1/${result.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()}`" class="nounderline" -->
                                            <div class="image-container">
                                                <img class="jw-img-1" :src="result.img_url" :alt="result.title" :title="result.title" />
                                                <p class="text-wrap-title-1 align-to-bottom cursor">{{ formattedDuration(result.duration) }}</p>
                                            </div>
                                            <!-- <img class="jw-img" :src="result.img_url" :alt="result.title" :title="result.title" /> -->
                                            <p class="cursor video-title" >{{result.title}}</p>
                                        <!-- /a -->
                                        </router-link>
                                    </div>
                                    <div v-else>
                                        <div class="image-container">
                                            <img v-a11y-action :aria-label="result.title" class="jw-img-1" :src="result.img_url" @click="setVideoPlayerObject(result.videoCode, result.title)" :alt="result.title" :title="result.title" />
                                            <!-- img class="jw-img-1" :src="result.img_url" @click="playVideoFunc(result.videoCode, result.title)" :alt="result.title" :title="result.title" / -->
                                            <p class="text-wrap-title-1 align-to-bottom cursor">{{ formattedDuration(result.duration) }}</p>
                                        </div>
                                        <!-- <img class="jw-img" :src="result.img_url" @click="setVideoPlayerObject(result.videoCode, result.title)" :alt="result.title" :title="result.title" /> -->
                                        <p v-a11y-action class="cursor video-title" @click="setVideoPlayerObject(result.videoCode, result.title)">{{result.title}}</p>
                                        <!-- p class="cursor video-title" @click="playVideoFunc(result.videoCode, result.title)">{{result.title}}</p -->
                                    </div>
                                    <hr v-if="user">
                                    <div class="plusicon btn-group" v-if="user">
                                        <button aria-label="Add video to a playlist" title="Add to Playlist" :id="result.mediaid" type="button" @click="showPlaylistMenu(result.mediaid)" class="dropdown-toggle ellipsis pull-right">
    <!--                                            <img src="../assets/playlist-icon.png" class="menuiconbutton" alt="Playlist" title="Playlist"/>-->
                                            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="37px" height="24px" viewBox="0 0 37 24" enable-background="new 0 0 37 24" xml:space="preserve">
                                                <rect y="0.2" :fill="getCorpHeaderColor" width="25" height="3"/>
                                                <rect y="8.2" :fill="getCorpHeaderColor" width="25" height="3"/>
                                                <rect y="17.2" :fill="getCorpHeaderColor" width="18.2" height="3"/>
                                                <rect x="23" y="15.2" :fill="getCorpHeaderColor" width="14" height="4"/>
                                                <rect x="27.958" y="10.242" :fill="getCorpHeaderColor" width="4" height="13.917"/>
                                            </svg>
                                        </button>
                                        <ul class="hide">
                                            <li  v-if="getUserPlaylists">
                                                <label>
                                                    <b> Add to ...</b>
                                                </label>
                                            </li>
                                            <li role="separator" class="divider"  v-if="getUserPlaylists"></li>
                                            <li v-if="getUserPlaylists" v-for="playlist in getUserPlaylists">
                                                <label class="notificationwithcheckboxes">
                                                    <input type="checkbox" :checked="verifyVideoExists(playlist, result)" @click="setPlaylistVideoStatus(result, playlist, verifyVideoExists(playlist, result)) "/> {{playlist.title}}
                                                    <transition name="fade">
                                                        <!--<h6 v-if="video.mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoAdded">Added</h6>-->
                                                        <span class="added" v-if="result.mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoAdded">Added</span>
                                                    </transition>
                                                    <transition name="fade">
                                                        <span class="removed" v-if="result.mediaid === selectedVideo && playlist.playlistId === selectedPlaylist && videoRemoved">Removed</span>
                                                    </transition>
                                                </label>
                                            </li>
                                            <li role="separator" class="divider" v-if="getUserPlaylists"></li>
                                            <li><label style="color:#f0617d">Create new playlist</label></li>
                                            <li>
                                                <label>
                                                    <input aria-label="New playlist name" type="text" class="form-control" v-model="newPlaylistName" />
                                                    <i v-a11y-action aria-label="Insert New Playlist" class="fa fa-plus-circle" @click="addNewPlayList" title="Insert New Playlist"></i>
                                                </label>
                                            </li>
                                        </ul>
                                        <div class="backdropformenu"  @click="hidePlaylistMenu(result.mediaid)"></div>
                                    </div>
                                    <p class="right-heart-icon" v-if="user && getAuthUserVideos">
                                        <a v-a11y-action aria-label="Liked this video?" href="javascript:" @click="setVideoStatus(result)" title ="Liked this video?">
                                            <i class="fa fa-2x fa-heart-o" v-bind:style="{ color: getCorpHeaderColor}"
                                                v-bind:class="{'activeIcons': getVideoStatus(result)}" aria-hidden="true" ></i></a>
                                    </p>
                                </div>
                                </div>
                            </div>
                            <!-- 1 ================================================================= 2024 =================================================  -->
                            <div class="tabContent" id="tabs-3" :class="{ current: tabs.playlists }">
                                <div class="row video-row">
                                    <!-- 2 ================================================================= 2024 =================================================  -->
                                    <span v-if="getSearchPlaylistResults && getSearchPlaylistResults.userPlaylists && getSearchPlaylistResults.userPlaylists.length > 0">
                                                <div class="col-xs-12 col-sm-6 col-md-4 bottom-margin" :class="{'innerimggray': getTrialDays < 0}" v-for = "playlist in limitTo(searchPlaylistResult)" v-if="playlist.userPlaylistVideos">
                                                    <div >
                                                        <div class="viderowraper image-container" :class="{'innerimggray': getTrialDays < 0}">
                                                            <!-- div class="favnumbers" v-bind:style="{ backgroundColor: getCorpHeaderColor}"><div><span>{{playlist.allVidDurInMinutes}}</span><small>mins</small></div>
                                                                    <i title="Play" class="fa fa-play-circle-o" @click="playPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode)"></i>
                                                                    <i v-if="playlist.userPlaylistType === 1" title="Remove" class="fa fa-trash" @click="removePlaylist(playlist.playlistId)"></i>
                                                                    <i v-if="playlist.haveCorporationVideo === 0 && ((user && user.corporation === null) || (user && user.corporation && user.corporation.corpSharingPermissions && user.corporation.corpSharingPermissions.sharePersonalPlaylistPermission >= 1))" title="Share Playlist" class="fa fa-share-square-o" @click="showSharingModal(playlist, 'personal')"></i>
                                                                    <i v-if="playlist.haveCorporationVideo === 1" title="This playlist contains videos which are private and cannot be shared" class="fa fa-share-square-o" @click="showPrivateVideoShareMsg()"></i>
                                                                </div -->
                                                            <!-- img v-if="playlist.userPlaylistType === 1" class="jw-img" :src="playlist.userPlaylistVideos[0].thumbnailURL" @click="playPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode)" :alt="playlist.title" :title="playlist.title" />
                                                            <img v-if="playlist.userPlaylistType === 2" class="jw-img" :src="playlist.userPlaylistVideos[0].thumbnailURL" @click="playTrendingPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode, playlist.title)" :alt="playlist.title" :title="playlist.title" />
                                                            <img v-if="playlist.corporationId > 0" class="jw-img" :src="playlist.userPlaylistVideos[0].thumbnailURL" @click="playCorpPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode, playlist.title)" :alt="playlist.title" :title="playlist.title" / -->

                                                             <!-- div class="image-container" -->
                                                                <img v-a11y-action :aria-label="playlist.title" v-if="playlist.userPlaylistType === 1" class="jw-img" :src="playlist.userPlaylistVideos[0].thumbnailURL" @click="playPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode)" :alt="playlist.title" :title="playlist.title" />
                                                                <img v-a11y-action :aria-label="playlist.title" v-if="playlist.userPlaylistType === 2" class="jw-img" :src="playlist.userPlaylistVideos[0].thumbnailURL" @click="playTrendingPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode, playlist.title)" :alt="playlist.title" :title="playlist.title" />
                                                                <img v-a11y-action :aria-label="playlist.title" v-if="playlist.corporationId > 0" class="jw-img" :src="playlist.userPlaylistVideos[0].thumbnailURL" @click="playCorpPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode, playlist.title)" :alt="playlist.title" :title="playlist.title" />
                                                                <p class="text-wrap-title-1 align-to-bottom cursor">{{ formattedDuration(playlist.allVidDurInSeconds) }}</p>
                                                            <!-- /div -->


                                                        </div>
                                                        <p v-a11y-action class="text-wrap-title cursor" v-if="playlist.userPlaylistType === 1" @click="playPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode)"> {{playlist.title}}</p>
                                                        <p v-a11y-action class="text-wrap-title cursor" v-if="playlist.userPlaylistType === 2" @click="playTrendingPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode, playlist.title)"> {{playlist.title}}</p>
                                                        <p v-a11y-action class="text-wrap-title cursor" v-if="playlist.corporationId > 0" @click="playCorpPlaylist(playlist.playlistId, playlist.userPlaylistVideos[0].videoCode, playlist.title)"> {{playlist.title}}</p>
                                                    </div>
                                                </div>
                                        </span>
                                    <!-- 3 ================================================================= 2024 =================================================  -->
                                </div>
                            </div>
                            <!-- 4 ================================================================= 2024 =================================================  -->



                        </div>

                        <span v-if="tabs.videos">
                            <div v-if="(getSearchResults ? getSearchResults.length : 0) > 6">
                                <pagination
                                    for="searchResults"
                                    ref="searchResults"
                                    v-model="page.videos"
                                    :per-page="pageLimit"
                                    @paginate="setPage('videos', $event, 1)"
                                    :records="getSearchResults.length">
                                </pagination>
                            </div>
                        </span>

                        <span v-if="tabs.events">
                            <div v-if="(getSearchExpertResults ? getSearchExpertResults.length : 0) > 6">
                                <pagination
                                    for="searchEventResults"
                                    ref="searchEventResults"
                                    v-model="page.events"
                                    :per-page="pageLimit"
                                    @paginate="setPage('events', $event, 2)"
                                    :records="getSearchExpertResults.length">
                                </pagination>
                            </div>
                        </span>

                        <span v-if="tabs.playlists">
                            <!-- div v-if="(getSearchPlaylistResults ? getSearchPlaylistResults.userPlaylists.length : 0) > 6" -->
                            <div v-if="(getSearchPlaylistResults && getSearchPlaylistResults.userPlaylists && getSearchPlaylistResults.userPlaylists.length ? getSearchPlaylistResults.userPlaylists.length : 0) > 6">
                                <pagination
                                    for="searchPlaylistResult"
                                    ref="searchPlaylistResult"
                                    v-model="page.playlists"
                                    :per-page="pageLimit"
                                    @paginate="setPage('playlists', $event, 3)"
                                    :records="getSearchPlaylistResults.userPlaylists.length">
                                </pagination>
                            </div>
                        </span>

                    </div>
                </div>
            </div>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import spinner from '@/accessibility/Spinner'
import alert from '@/accessibility/Alert'

import Pagination from 'vue-pagination-2'
import store from '../store'
import $ from 'jquery'

export default {
    components: {
        spinner: spinner,
        alert: alert,
        pagination: Pagination
    },
    name: 'search',
    metaInfo () {
        return {
            title: 'TONE | Search',
            meta: [
                {property: 'og:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg'},
                {property: 'og:title', content: 'TONE | Search'},
                {property: 'og:site_name', content: 'TONE Networks | Expert Advice on Demand'},
                {
                    property: 'og:description',
                    content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
                },
                {property: 'twitter:title', content: 'TONE | Search'},
                {property: 'twitter:card', content: 'summary'},
                {property: 'twitter:image', content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/slide-1.jpg'},
                {
                    property: 'twitter:description',
                    content: 'TONE Networks provides women with resources and support to help them flourish in every aspect of their lives.'
                },
                {property: 'og:image:width', content: '300'},
                {property: 'og:image:height', content: '300'}
            ]
        }
    },
    data: function () {
        return {
            contentToSearch: '',
            pageLimit: 6,
            pageStart: 1,
            pageEnd: 6,
            enteredValue: '',
            spinner: false,
            isBlankField: false,
            isEmptyResponse: false,
            currentPlan: '',
            signUpPath: '',
            sortOrder: false,
            tabs: {
                videos: true,
                events: false,
                playlists: false
            },
            newPlaylistName: '',
            videoAdded: false,
            videoRemoved: false,
            selectedVideo: 0,
            selecedPlaylist: 0,
            isNativeApp: false,
            searchResults: null,
            searchEventResults: null,
            searchPlaylistResult: null,
            // page: 1,
            page: {
                videos: 1,
                events: 1,
                playlists: 1
            },
            eventsPage: 1,
            playlistPage: 1,
            orderBy: ['asc']
        }
    },
    mounted () {
        if (navigator.userAgent.indexOf('gonative') > -1) {
            this.isNativeApp = true
        }
        let currTabName = 'videos'
        let currPageNum = 1
        let qryString = this.$route.params.qryString
        let storedSearch = sessionStorage.getItem('searchQry')
        console.log('mounted () : storedSearch : ;' + storedSearch + ';, qryString = ;' + qryString + ';')
        let page = {
            videos: 1,
            events: 1,
            playlists: 1
        }
        if (qryString) {
            console.log('mounted () : qryString : storedSearch : ;' + storedSearch + ';, qryString = ;' + qryString + ';')
            this.contentToSearch = qryString.trim()
            this.initiateSearch()
            storedSearch = null
        }
        if (storedSearch) {
            console.log('mounted () : storedSearch : storedSearch : ;' + storedSearch + ';, qryString = ;' + qryString + ';')
            this.contentToSearch = storedSearch.trim()
            this.loadOldSearch(qryString, page)
        }
        if (this.getMarketingPlan) {
            this.$store.dispatch('GETPLAN', this.getMarketingPlan).then(() => {
                this.currentPlan = this.getDefaultPlan
                this.signUpPath = `signup/${this.getMarketingPlan}`
            })
        } else {
            this.$store.dispatch('GETPLAN', '1MonthPlanChrgLate').then(() => {
                this.currentPlan = this.getDefaultPlan
                this.signUpPath = `signup`
            })
        }

        if (sessionStorage.getItem('currTabName')) {
            currTabName = sessionStorage.getItem('currTabName')
        }
        console.log('mounted () : (sessionStorage.getItem(\'videoTabCurPageNum\')) = ' + (sessionStorage.getItem('videoTabCurPageNum')))
        this.switchTab(currTabName)
        if (currTabName === 'videos') {
            if (sessionStorage.getItem('videoTabCurPageNum')) {
                currPageNum = parseInt(sessionStorage.getItem('videoTabCurPageNum'))
                console.log('mounted () : (sessionStorage.getItem(\'videoTabCurPageNum\')) = ' + (sessionStorage.getItem('videoTabCurPageNum')))
            }
            // if (page.videos > 1 && this.getSearchResults && this.getSearchResults.length > 0) {
            if (this.getSearchResults && this.getSearchResults.length > 0) {
                this.setPage(currTabName, currPageNum, 41)
                this.page = page
            }
        } else if (currTabName === 'events') {
            if (sessionStorage.getItem('eventTabCurPageNum')) {
                currPageNum = parseInt(sessionStorage.getItem('eventTabCurPageNum'))
            }
            if (this.getSearchExpertResults && this.getSearchExpertResults.length > 0) {
                this.setPage(currTabName, currPageNum, 42)
                this.page = page
            }
        } else if (currTabName === 'playlists') {
            if (sessionStorage.getItem('plistTabCurPageNum')) {
                currPageNum = parseInt(sessionStorage.getItem('plistTabCurPageNum'))
            }
            if (this.getSearchPlaylistResults && this.getSearchPlaylistResults.userPlaylists && this.getSearchPlaylistResults.userPlaylists.length > 0) {
                this.setPage(currTabName, currPageNum, 43)
                this.page = page
            }
        }
        console.log('mounted () : currTabName = ' + currTabName + ' >>> currPageNum = ' + currPageNum)
        console.log('mounted () : this.user.userId : ;' + this.user.userId + ';, this.user = ;' + this.user + '; this.contentToSearch = ;' + this.contentToSearch + ';')
        this.$store.dispatch('GETAUTHUSERVIDEOS', this.user && this.user.userId).then(() => {
            // this.charities = this.getAuthUserVideos
        })
        // Get User Playlists
        this.$store.dispatch('GETUSERPLAYLISTS', this.user && this.user.userId).then(() => {
            // this.charities = this.getAuthUserVideos
        })
    },
    methods: {
        formattedDuration (duration) {
            const hours = Math.floor(duration / 3600)
            const minutes = Math.floor((duration % 3600) / 60)
            const seconds = duration % 60
            const formattedHours = hours > 0 ? `${hours}:` : ''
            const formattedMinutes = minutes > 0 ? `${minutes}:` : '0:'
            const formattedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`
            return `${formattedHours}${formattedMinutes}${formattedSeconds}`
        },
        sort: function (value) {
            let corpId = 0
            if (this.user && this.user.corporation && this.user.corporation.corporationId > 0) {
                corpId = this.user.corporation.corporationId
            }
            this.spinnerToggle()
            let searchObject = {
                userId: this.user.userId,
                contentToSearch: this.contentToSearch,
                corporationId: corpId,
                sortby: value,
                sortorder: this.sortOrder ? 1 : -1
            }
            this.sortOrder = !this.sortOrder
            this.$store.dispatch('SORTDATA', searchObject).then((res) => {
                // if (this.getSearchResults['length'] !== 0) {
                //     this.searchResults = this.getSearchResults
                // } else {
                //     this.isEmptyResponse = true
                //     this.refreshSearch()
                // }
                let lastContentToSearch = ''
                if (sessionStorage.getItem('searchQry')) {
                    lastContentToSearch = sessionStorage.getItem('searchQry')
                }
                if (this.contentToSearch !== lastContentToSearch) {
                    this.refreshSearch()
                }
                if (this.getSearchResults && this.getSearchResults.length !== 0) {
                    this.searchResults = this.getSearchResults
                    // setTimeout(() => {
                    // }, 5000)
                } else {
                    this.searchResults = null
                }
                if (this.getSearchExpertResults && this.getSearchExpertResults.length !== 0) {
                    this.searchEventResults = this.getSearchExpertResults
                } else {
                    this.searchEventResults = null
                }
                if (this.getSearchPlaylistResults && this.getSearchPlaylistResults.userPlaylists && this.getSearchPlaylistResults.userPlaylists.length !== 0) {
                    this.searchPlaylistResult = this.getSearchPlaylistResults.userPlaylists
                } else {
                    this.searchPlaylistResult = null
                }
                // 01/06/2024 - Janauary 06, 2024
                if (this.searchResults === null && this.searchEventResults === null && this.searchPlaylistResult === null) {
                    this.isEmptyResponse = true
                    this.refreshSearch()
                } else {
                    sessionStorage.setItem('searchQry', this.contentToSearch)
                }
                this.spinnerToggle()
            })
            this.$forceUpdate()
        },
        sortArrow: function () {
            if (this.orderBy[0] === 'asc') {
                return '↑'
            }
            return '↓'
        },
        setPage (tab, current, calledFrom) {
            let self = this
            var totalPages, difference
            console.log('Entered setPage : tab = ;' + tab + '; >>>> current = ;' + current + '; >>> calledFrom = ' + calledFrom)
            sessionStorage.setItem('currTabName', tab)
            // totalPages = self.getSearchResults['length']
            if (tab === 'videos') {
                sessionStorage.setItem('videoTabCurPageNum', current)
                console.log('setPage : ================= (sessionStorage.getItem(\'videoTabCurPageNum\')) = ' + (sessionStorage.getItem('videoTabCurPageNum')))
                if (self.getSearchResults && self.getSearchResults['length'] !== 0) { totalPages = self.getSearchResults['length'] }
            } else if (tab === 'events') {
                sessionStorage.setItem('eventTabCurPageNum', current)
                if (self.getSearchExpertResults && self.getSearchExpertResults['length'] !== 0) { totalPages = self.getSearchExpertResults['length'] }
            } else if (tab === 'playlists') {
                sessionStorage.setItem('plistTabCurPageNum', current)
                if (self.getSearchPlaylistResults && self.getSearchPlaylistResults.userPlaylists && self.getSearchPlaylistResults.userPlaylists.length !== 0) { totalPages = self.getSearchPlaylistResults.userPlaylists.length }
            }
            console.log('Entered setPage : totalPages = ;' + totalPages + ';')
            if ((current * self.pageLimit) > totalPages) {
                self.pageStart = ((current * self.pageLimit) - self.pageLimit) + 1
                difference = (current * self.pageLimit) - totalPages
                self.pageEnd = (current * self.pageLimit) - difference
            } else {
                self.pageEnd = current * self.pageLimit
                self.pageStart = (self.pageEnd - self.pageLimit) + 1
            }
            self.page[tab] = current
        },
        switchTab: function (id) {
            console.log('Entered switchTab : id = ;' + id + '; >>>>>>>>>>>>> Object.values(this.tabs) = ' + Object.values(this.tabs))
            let currPageNum = 1
            for (let tab in this.tabs) {
                if (id === 'videos') {
                    if (sessionStorage.getItem('videoTabCurPageNum')) {
                        currPageNum = parseInt(sessionStorage.getItem('videoTabCurPageNum'))
                        console.log('switchTab () : id = ' + id + ' >>> currPageNum = ' + currPageNum)
                    }
                } else if (id === 'events') {
                    if (sessionStorage.getItem('eventTabCurPageNum')) {
                        currPageNum = parseInt(sessionStorage.getItem('eventTabCurPageNum'))
                        console.log('switchTab () : id = ' + id + ' >>> currPageNum = ' + currPageNum)
                    }
                } else if (id === 'playlists') {
                    if (sessionStorage.getItem('plistTabCurPageNum')) {
                        currPageNum = parseInt(sessionStorage.getItem('plistTabCurPageNum'))
                        console.log('switchTab () : id = ' + id + ' >>> currPageNum = ' + currPageNum)
                    }
                }
                this.setPage(id, currPageNum, 5)
                this.tabs[tab] = id === tab
                console.log('Entered switchTab : tab = ;' + tab + '; >>>>>>>>>>>>> Object.values(this.page) = ' + Object.values(this.page))
            }
        },
        redirectToSignUp () {
            if (this.getMarketingPlan) {
                this.$router.push('/signup/' + this.getMarketingPlan)
            } else {
                this.$router.push('/signup')
            }
        },
        loadOldSearch (qry, page) {
            console.log('Entered loadOldSearch')
            console.log('Entered loadOldSearch : qry = ;' + qry + '; >>>>> page = ;' + page + '; this.contentToSearch = ;' + this.contentToSearch + ';')
            console.log('Entered loadOldSearch : this.pageStart = ;' + this.pageStart + '; >>>>> this.pageEnd = ;' + this.pageEnd + ';')
            this.pageStart = 1
            this.pageEnd = 6
            if (this.contentToSearch.length !== 0) {
                this.enteredValue = this.contentToSearch
                this.isBlankField = false
                this.isEmptyResponse = false
                this.spinnerToggle()
                let corpId = 0
                if (this.user && this.user.corporation && this.user.corporation.corporationId > 0) {
                    corpId = this.user.corporation.corporationId
                }
                let params = {
                    userId: this.user && this.user.userId,
                    contentToSearch: this.contentToSearch,
                    corporationId: corpId,
                    sortby: '_score',
                    sortorder: -1
                }
                this.$store.dispatch('GETSEARCHRESULTS_POST', params).then(() => {
                    window.logEvents('Search Page', 'click', `Title Searched: ${this.contentToSearch}`)
                    let lastContentToSearch = ''
                    if (sessionStorage.getItem('searchQry')) {
                        lastContentToSearch = sessionStorage.getItem('searchQry')
                    }
                    if (this.contentToSearch !== lastContentToSearch) {
                        this.refreshSearch()
                    }
                    // sessionStorage.setItem('searchQry', this.contentToSearch)
                    // if (this.getSearchResults && this.getSearchResults['length'] !== 0) {
                    //     this.searchResults = this.getSearchResults
                    //     //
                    //     // let currPage = 1
                    //     // setTimeout(() => {
                    //     //     if (page.videos > 1 && this.getSearchResults && this.getSearchResults.length > 0) {
                    //     //         // this.setPage('videos', page)
                    //     //         if (sessionStorage.getItem('videoTabCurPageNum')) {
                    //     //             console.log('loadOldSearch () : sessionStorage.getItem(\'videoTabCurPageNum\') : ;' + sessionStorage.getItem('videoTabCurPageNum') + ';')
                    //     //             currPage = parseInt(sessionStorage.getItem('videoTabCurPageNum'))
                    //     //         }
                    //     //         // this.setPage('videos', 1)
                    //     //         this.setPage('videos', currPage, 6)
                    //     //         this.page = page
                    //     //     }
                    //     // }, 1000)
                    // } else {
                    //     this.isEmptyResponse = true
                    //     this.refreshSearch()
                    // }
                    // if (this.getSearchExpertResults && this.getSearchExpertResults.length !== 0) {
                    //     this.searchEventResults = this.getSearchExpertResults
                    // }
                    // if (this.getSearchPlaylistResults && this.getSearchPlaylistResults.length !== 0) {
                    //     this.searchPlaylistResult = this.getSearchPlaylistResults.userPlaylists
                    // }
                    // ================================================================================= 01/06/2024 below
                    if (this.getSearchResults && this.getSearchResults.length !== 0) {
                        this.searchResults = this.getSearchResults
                        // sessionStorage.setItem('searchQry', this.contentToSearch)
                        // setTimeout(() => {
                        // }, 5000)
                    } else {
                        this.searchResults = null
                        // 01/06/2024 - Janauary 06, 2024
                        // this.isEmptyResponse = true
                        // this.refreshSearch()
                    }
                    if (this.getSearchExpertResults && this.getSearchExpertResults.length !== 0) {
                        this.searchEventResults = this.getSearchExpertResults
                    } else {
                        this.searchEventResults = null
                    }
                    if (this.getSearchPlaylistResults && this.getSearchPlaylistResults.userPlaylists && this.getSearchPlaylistResults.userPlaylists.length !== 0) {
                        this.searchPlaylistResult = this.getSearchPlaylistResults.userPlaylists
                    } else {
                        this.searchPlaylistResult = null
                    }
                    // 01/06/2024 - Janauary 06, 2024
                    if (this.searchResults === null && this.searchEventResults === null && this.searchPlaylistResult === null) {
                        this.isEmptyResponse = true
                        this.refreshSearch()
                    } else {
                        sessionStorage.setItem('searchQry', this.contentToSearch)
                    }
                    // ================================================================================= 01/06/2024  == above
                    // let currPage = 1
                    // setTimeout(() => {
                    //     if (page.videos > 1 && this.getSearchResults && this.getSearchResults.length > 0) {
                    //         // this.setPage('videos', page)
                    //         if (sessionStorage.getItem('videoTabCurPageNum')) {
                    //             console.log('loadOldSearch () : sessionStorage.getItem(\'videoTabCurPageNum\') : ;' + sessionStorage.getItem('videoTabCurPageNum') + ';')
                    //             currPage = parseInt(sessionStorage.getItem('videoTabCurPageNum'))
                    //         }
                    //         // this.setPage('videos', 1)
                    //         this.setPage('videos', currPage, 6)
                    //         this.page = page
                    //     }
                    // }, 1000)
                    let currTabName = 'videos'
                    let currPageNum = 1
                    if (sessionStorage.getItem('currTabName')) {
                        currTabName = sessionStorage.getItem('currTabName')
                        console.log('loadOldSearch () : currTabName = ' + currTabName)
                    }
                    if (currTabName === 'videos') {
                        if (sessionStorage.getItem('videoTabCurPageNum')) {
                            currPageNum = parseInt(sessionStorage.getItem('videoTabCurPageNum'))
                            console.log('loadOldSearch () : currTabName = ' + currTabName + ' >>> currPageNum = ' + currPageNum)
                        }
                    } else if (currTabName === 'events') {
                        if (sessionStorage.getItem('eventTabCurPageNum')) {
                            currPageNum = parseInt(sessionStorage.getItem('eventTabCurPageNum'))
                            console.log('loadOldSearch () : currTabName = ' + currTabName + ' >>> currPageNum = ' + currPageNum)
                        }
                    } else if (currTabName === 'playlists') {
                        if (sessionStorage.getItem('plistTabCurPageNum')) {
                            currPageNum = parseInt(sessionStorage.getItem('plistTabCurPageNum'))
                            console.log('loadOldSearch () : currTabName = ' + currTabName + ' >>> currPageNum = ' + currPageNum)
                        }
                    }
                    console.log('loadOldSearch () : currTabName = ' + currTabName + ' >>> currPageNum = ' + currPageNum)
                    // page.videos = parseInt(sessionStorage.getItem('videoTabCurPageNum'))
                    this.setPage(currTabName, currPageNum, 6)
                    this.spinnerToggle()
                })
            } else {
                this.$swal({
                    title: 'Please type something, the input field seems to be blank.',
                    text: '',
                    type: 'question',
                    timer: 3000,
                    showCancelButton: false,
                    showConfirmButton: false
                }).then(
                    function () {
                    },
                    // handling the promise rejection
                    function (dismiss) {
                        if (dismiss === 'timer') {
                        }
                    }
                )
                // this.isBlankField = true
            }
        },
        initiateSearch () {
            console.log('Entered : initiateSearch')
            this.page.videos = 1
            this.page.events = 1
            this.page.playlists = 1
            this.pageStart = 1
            this.pageEnd = 6
            if (this.contentToSearch.length !== 0) {
                this.enteredValue = this.contentToSearch
                this.isBlankField = false
                this.isEmptyResponse = false
                this.spinnerToggle()
                let corpId = 0
                if (this.user && this.user.corporation && this.user.corporation.corporationId > 0) {
                    corpId = this.user.corporation.corporationId
                }
                // let params = [this.contentToSearch, corpId]
                let params = {
                    userId: this.user && this.user.userId,
                    contentToSearch: this.contentToSearch,
                    corporationId: corpId,
                    sortby: '_score',
                    sortorder: -1
                }
                this.$store.dispatch('GETSEARCHRESULTS_POST', params).then(() => {
                    window.logEvents('Search Page', 'click', `Title Searched: ${this.contentToSearch}`)
                    let lastContentToSearch = ''
                    if (sessionStorage.getItem('searchQry')) {
                        lastContentToSearch = sessionStorage.getItem('searchQry')
                    }
                    if (this.contentToSearch !== lastContentToSearch) {
                        this.refreshSearch()
                    }
                    // sessionStorage.setItem('searchQry', this.contentToSearch)
                    if (this.getSearchResults && this.getSearchResults.length !== 0) {
                        this.searchResults = this.getSearchResults
                        setTimeout(() => {
                        }, 5000)
                    } else {
                        this.searchResults = null
                        // 01/06/2024 - Janauary 06, 2024
                        // this.isEmptyResponse = true
                        // this.refreshSearch()
                    }
                    if (this.getSearchExpertResults && this.getSearchExpertResults.length !== 0) {
                        this.searchEventResults = this.getSearchExpertResults
                    } else {
                        this.searchEventResults = null
                    }
                    if (this.getSearchPlaylistResults && this.getSearchPlaylistResults.userPlaylists && this.getSearchPlaylistResults.userPlaylists.length !== 0) {
                        this.searchPlaylistResult = this.getSearchPlaylistResults.userPlaylists
                    } else {
                        this.searchPlaylistResult = null
                    }
                    //  below part commented on Monday 01/08/2024 - Janauary 08, 2024
                    if (this.searchResults === null && this.searchEventResults === null && this.searchPlaylistResult === null) {
                        this.isEmptyResponse = true
                        this.refreshSearch()
                    } else {
                        sessionStorage.setItem('searchQry', this.contentToSearch)
                    }
                    this.spinnerToggle()
                })
            } else {
                this.$swal({
                    title: 'Please type something, the input field seems to be blank.',
                    text: '',
                    type: 'question',
                    timer: 3000,
                    showCancelButton: false,
                    showConfirmButton: false
                }).then(
                    function () {
                    },
                    // handling the promise rejection
                    function (dismiss) {
                        if (dismiss === 'timer') {
                        }
                    }
                )
               // this.isBlankField = true
            }
        },
        setVideoPlayerObject (videoCode, videoTitle) {
            // this.$router.push('/watch/' + videoCode)
            if (this.user && this.getTrialDays < 0) {
                if (sessionStorage.getItem('redirectPath')) {
                    sessionStorage.removeItem('redirectPath')
                    sessionStorage.setItem('redirectPath', `/watch/${videoCode}/${videoTitle.replace(/\\s/g, '-').toLowerCase()}`)
                } else {
                    sessionStorage.setItem('redirectPath', `/watch/${videoCode}/${videoTitle.replace(/\\s/g, '-').toLowerCase()}`)
                }
                this.$router.push(`/becomemember`)
            } else if (this.user) {
                this.$router.push(`/watch/${videoCode}/${videoTitle.replace(/\\s/g, '-').toLowerCase()}`)
            } else {
                if (sessionStorage.getItem('redirectPath')) {
                    sessionStorage.removeItem('redirectPath')
                    sessionStorage.setItem('redirectPath', `/watch/${videoCode}/${videoTitle.replace(/\\s/g, '-').toLowerCase()}`)
                } else {
                    sessionStorage.setItem('redirectPath', `/watch/${videoCode}/${videoTitle.replace(/\\s/g, '-').toLowerCase()}`)
                }
                store.commit('setTriggerLogin', {loginStatus: true})
            }
        },
        spinnerToggle () {
            this.spinner = !this.spinner
        },
        limitTo (arr) {
            console.log('Entered : limitTo')
            console.log('Entered : limitTo = ;' + arr + '; >>> this.pageStart = ;' + this.pageStart + '; >>> this.pageEnd = ;' + this.pageEnd + ';')
            if (Array.isArray(arr)) {
                // let elem1 = arr[0]
                // const myArray = Object.values(elem1)
                let currTabName = 'videos'
                let currPageNum = 1
                if (sessionStorage.getItem('currTabName')) {
                    currTabName = sessionStorage.getItem('currTabName')
                    console.log('11 limitTo () : currTabName = ' + currTabName + ' >>> currPageNum = ' + currPageNum)
                }
                if (currTabName === 'videos') {
                    if (sessionStorage.getItem('videoTabCurPageNum')) {
                        currPageNum = parseInt(sessionStorage.getItem('videoTabCurPageNum'))
                        console.log('22 limitTo () : currTabName = ' + currTabName + ' >>> currPageNum = ' + currPageNum)
                    }
                } else if (currTabName === 'events') {
                    if (sessionStorage.getItem('eventTabCurPageNum')) {
                        currPageNum = parseInt(sessionStorage.getItem('eventTabCurPageNum'))
                        console.log('33 limitTo () : currTabName = ' + currTabName + ' >>> currPageNum = ' + currPageNum)
                    }
                } else if (currTabName === 'playlists') {
                    if (sessionStorage.getItem('plistTabCurPageNum')) {
                        currPageNum = parseInt(sessionStorage.getItem('plistTabCurPageNum'))
                        console.log('44 limitTo () : currTabName = ' + currTabName + ' >>> currPageNum = ' + currPageNum)
                    }
                }
                console.log('55 limitTo () : currTabName = ' + currTabName + ' >>> currPageNum = ' + currPageNum)
                this.setPage(currTabName, currPageNum, 7)
                return arr && arr.slice(this.pageStart - 1, this.pageEnd)
            }
            return []
                // return arr && arr.slice(this.pageStart - 1, this.pageEnd)
        },
        getVideoStatus (videoObject) {
            if (this.getAuthUserVideos) {
                let mediaId = videoObject.mediaid
                let exists = this.getAuthUserVideos && this.getAuthUserVideos.filter(videoObject => {
                    return videoObject.videoCode === mediaId
                })
                if (exists && exists.length > 0 && exists[0].liked === '1') {
                    return true
                } else {
                    return false
                }
            } else {
                return false
            }
        },
        setVideoStatus (videoObject) {
            if (this.getAuthUserVideos) {
                let mediaId = videoObject.mediaid
                let exists = this.getAuthUserVideos && this.getAuthUserVideos.filter(videoObject => {
                    return videoObject.videoCode === mediaId
                })
                if (exists && exists.length > 0) {
                    if (exists[0].liked === '1') {
                        exists[0].liked = '0'
                    } else {
                        exists[0].liked = '1'
                    }
                    this.$store.dispatch('SETVIDEOSTATUS', exists[0]).then(() => {
                        this.$store.dispatch('GETAUTHUSERVIDEOS', this.user.userId)
                    })
                } else {
                    let logWatchedEntry = {
                        videoCode: videoObject.mediaid,
                        userId: this.user.userId,
                        playlistId: null,
                        playlistCode: null,
                        watched: 'N',
                        rating: null,
                        liked: '1',
                        durationWatched: 0,
                        thumbnailURL: null,
                        opinion: null
                    }
                    this.$store.dispatch('SETVIDEOSTATUS', logWatchedEntry).then(() => {
                        this.$store.dispatch('GETAUTHUSERVIDEOS', this.user.userId)
                    })
                }
            }
        },
        setPlaylistVideoStatus (video, playlist, currentStatus) {
            let self = this
            self.selectedVideo = video.mediaid
            self.selectedPlaylist = playlist.playlistId
            if (currentStatus) { // Video is unSelected
                let payload = {}
                payload.videoCode = video.mediaid
                payload.userPlaylistId = playlist.playlistId
                payload.userId = this.user.userId
                this.$store.dispatch('REMOVEVIDEOFROMPLAYLIST', {playlist: payload}).then(() => {
                    self.videoAdded = false
                    self.videoRemoved = true
                })
            } else { // Video is Selected
                let payload = {}
                payload.videoCode = video.mediaid
                payload.userId = this.user.userId
                payload.userPlaylistId = playlist.playlistId
                this.$store.dispatch('ADDVIDEOINPLAYLIST', {playlist: payload}).then(() => {
                    // this.charities = this.getAuthUserVideos
                    self.videoAdded = true
                    self.videoRemoved = false
                })
            }
            setTimeout(() => {
                self.videoAdded = false
                self.videoRemoved = false
            }, 1500)
        },
        verifyPlaylistExists () {
            if (this.getUserPlaylists) {
                let playlistsWithVideo = this.getUserPlaylists && this.getUserPlaylists.filter(x => {
                    return x.userPlaylistVideos !== null
                })
                if (playlistsWithVideo && playlistsWithVideo.length > 0) {
                    return true
                } else {
                    return false
                }
            } else {
                return false
            }
        },
        verifyVideoExists (playlist, video) {
            let self = this
            if (this.getUserPlaylists) {
                let findPlaylist = this.getUserPlaylists && this.getUserPlaylists.filter(x => {
                    return x.playlistId === playlist.playlistId
                })
                if (findPlaylist && findPlaylist.length > 0) {
                    if (findPlaylist[0].userPlaylistVideos !== null && findPlaylist[0].userPlaylistVideos.length > 0) {
                        let videos = findPlaylist[0].userPlaylistVideos.filter(x => {
                            return x.videoCode === video.mediaid
                        })
                        if (videos && videos.length > 0) {
                            self.playlistHasVideo = true
                            return true
                        } else {
                            return false
                        }
                    } else {
                        return false
                    }
                } else {
                    return false
                }
            } else {
                return false
            }
        },
        addNewPlayList () {
            if (this.newPlaylistName && this.newPlaylistName.length > 0) {
                let payload = {}
                payload.userId = this.user.userId
                payload.title = this.newPlaylistName
                this.$store.dispatch('CREATEPLAYLIST', {playlist: payload}).then(() => {
                    this.newPlaylistName = ''
                    // this.charities = this.getAuthUserVideos
                })
            }
        },
        showPlaylistMenu (videoCode) {
            // console.log(videoCode)
            $('#' + videoCode + ' + ul').toggleClass('hide')
        },
        hidePlaylistMenu (videoCode) {
            // console.log(videoCode)
            $('#' + videoCode + ' + ul').toggleClass('hide')
        },
        refreshSearch () {
            console.log('refreshSearch () ===============================> : ')
            sessionStorage.removeItem('searchQry')
            sessionStorage.removeItem('currTabName')
            sessionStorage.removeItem('videoTabCurPageNum')
            sessionStorage.removeItem('eventTabCurPageNum')
            sessionStorage.removeItem('plistTabCurPageNum')
        },
        playPlaylist (playlistId, videoCode) {
            if (this.getTrialDays < 0) {
                this.$router.push(`/becomemember`)
            } else {
                this.$router.push(`/playlist/${playlistId}/play/${videoCode}`)
            }
        },
        playTrendingPlaylist (playlistId, videoCode, videoTitle) {
            if (this.getTrialDays < 0) {
                this.$router.push(`/becomemember`)
            } else {
                this.$router.push(`/playlist/trending/${playlistId}/play/${videoCode}/${videoTitle.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()}`)
            }
        },
        playCorpPlaylist (playlistId, videoCode, playlistTitle) {
            if (this.getTrialDays < 0) {
                this.$router.push(`/becomemember`)
            } else {
                this.$router.push(`/playlist/${playlistId}/play/${videoCode}/${this.user.corporation.corporationId}/${playlistTitle.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()}`)
            }
        },
        playVideoFunc (videoCode, videoTitle) {
            if (this.getTrialDays < 0) {
                this.$router.push(`/becomemember`)
            } else {
                // this.$router.push(`/playlist/${playlistId}/play/${videoCode}`)
                this.$router.push(`/watch/${videoCode}/${videoTitle.replace(/\\s/g, '-').toLowerCase()}`)
            }
        }
    },
    computed: {
        ...mapGetters([
            'error', 'getSearchResults', 'getSearchExpertResults', 'getSearchPlaylistResults', 'user', 'getDefaultPlan', 'getAllPlans', 'getMarketingPlan', 'getAuthUserVideos', 'getUserPlaylists', 'getTrialDays', 'getCorpHeaderColor', 'getCorpFooterColor', 'getCorpButtonColor', 'getCorpHeadingColor'
        ]),
        mFunc: function () {
            // console.log('Initial this.items.size: ' + Object.keys(this.items).length)
            return this.searchResults.length
        }
        // sortedData: function (sortByValue) {
        //     console.log('Entered sortedData')
        //     console.log('this.searchResults', this.searchResults)
        //     return _.orderBy(
        //         this.searchResults,
        //         [sortByValue],
        //         this.orderBy,
        //     )
        // }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    /*for vertical effect*/
    .text-wrap-title-1 {
        right: -14px;
        position: absolute;
        background-color: rgb(68, 189, 168) !important;
        color: #fff !important;
        font-size: 12px !important;
        padding: 2px 4px !important;
        border-top-left-radius: 4px !important;
        line-height: 1.1 !important;
    }
    .align-to-bottom {
        right: -13px !important;
        top: -9px !important;
    }
    .jw-img-1 {
        max-width: 100%; /* Ensure the image does not exceed its container width */
    }
    .image-container {
        position: relative;
        display: flex;
        justify-content: space-between;
    }
    .m-b-45 {
        margin-bottom: 40px !important;
    }
    .container__header {
        display: flex;
        max-width: var(--wrap-width);
        margin: 0 auto;
        justify-content: space-evenly;
        font-size: 30px;
        font-weight: 700;
        margin-bottom: 30px;
    }
    .container__header-item {
        padding: 0.3rem;
        border-radius: 2px;
        margin-right: 0.3rem;
        margin-bottom: 0.3rem;
        cursor: pointer;
        user-select: none;
        font-size: 16px;
        font-weight: 400;
    }
    .slide-search-fade-enter-active {
        transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .slide-search-fade-leave-active {
        transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .slide-search-fade-enter, .slide-search-fade-leave-to
        /* .slide-search-fade-leave-active for <2.1.8 */ {
        transform: translateY(10px);
        opacity: 0;
    }
    .search form input{height:50px;}
    h3 {
        color: #f0617d;
        font-size:19px;
    }
    @media(min-width:991px){
        h3 {
            width: 70.2%;
            margin: 0 auto 30px;
            display: block;
        }
    }
    @media (max-width: 992px) and (min-width: 768px){
        h3 {
            width: 80%;
            margin: 0 auto 30px;
            display: block;
        }
    }
    .right-heart-icon {
        margin: 0;
        float: left;
        width: 100%;
        padding: 10px 0 0 0;
    }
    .right-heart-icon i {
        color: #f0617d;
        float: right;
        font-size: 28px;
    }
    .row.video-row hr {
        margin: 0 1em;
        border: 0;
        border-top: 1px solid #eeeeee;
    }
    .btn-group.plusicon {
        position: absolute !important;
        right: 60px !important;
        bottom: 10px !important;
        height: 29px !important;
    }
    li.divider {
        border-bottom: 1px solid #ddd;
        margin: 5px -15px;
    }

    button.dropdown-toggle.ellipsis.pull-right {
        background: transparent;
        border: 0 none transparent;
        padding: 0;
    }
    button.dropdown-toggle.ellipsis.pull-right{
        font-size: 21px;
        top: 0;
    }
    button.dropdown-toggle.ellipsis.pull-right li label{
        padding: 30px;
    }
    button.dropdown-toggle.ellipsis.pull-right+ ul li label,
    button.dropdown-toggle.ellipsis.pull-right+ ul li a {
        padding: 3px 15px;
        margin-bottom: 5px;
        display: block;
    }
    button.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control,
    button.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control {
        height: 30px;
        padding: 5px 30px 5px 5px;
    }
    button.dropdown-toggle.ellipsis.pull-right+ ul li input.form-control + i.fa.fa-plus-circle,
    button.dropdown-toggle.ellipsis.pull-right+ div + ul li input.form-control + i.fa.fa-plus-circle {
        position: absolute;
        top: 6px;
        font-size:24px;
        right:20px;
        cursor: pointer;
    }
    button.dropdown-toggle.ellipsis.pull-right+ ul li label,
    button.dropdown-toggle.ellipsis.pull-right+div + ul li label{
        position:relative;
    }
    button.dropdown-toggle.ellipsis.pull-right+ div + ul,
    button.dropdown-toggle.ellipsis.pull-right+ ul{
        left: 0;
        right: auto;
        width: 230px;
        background: #fff;
        border: 1px solid #ddd;
        border-radius: 5px;
        top: 100%;
        position: absolute;
        z-index: 5000;
        list-style: none;
        text-align: left;
        padding: 15px;
    }
    .backdropformenu{
        position:fixed;
        z-index:4900;
        top:0;
        left:0;
        right:0;
        bottom:0;
        background: transparent;
    }
    .profile .tabContent .menuiconbutton{
        height: 24px;
        width: 37px;
    }
    .menuiconbutton{
        height: 24px !important;
        width: 37px !important;
    }
    .plusicon.btn-group > button.dropdown-toggle.ellipsis.pull-right+ul {
        left: auto ;
        right: 0;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }

    label.notificationwithcheckboxes span{
        font-size: 10px;
    }

    span.removed {
        color: red;
    }
    span.added {
        color: #4caa98;
    }

    label.notificationwithcheckboxes {
        position: relative;
        display:block;
    }
    .search .tabContent p {
        font-size: 17px;
    }
</style>



// WEBPACK FOOTER //
// Search.vue?61563146